import React, { useState, useEffect, useCallback } from 'react';
import style from './MyDataSummary.module.css';

import MyInfoHelpGuideBox from '../../../../components/box/MyInfoHelpGuideBox'
import { useLocation, useNavigate } from 'react-router-dom';
import URL from '../../../../constants/url';
import Modal from "../../../../components/comm/Modal"
import CircularProgress from '@mui/material/CircularProgress';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';

import InspectionGraphBox from '../../../../components/box/InspectionGraphBox';

import noDoctorImgPng from '../../../../images/user/i_3d_hospital_inform_link_01.png';

import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';

import cancer from '../../../../images/user/i_disease_01.svg';
import cancerOff from '../../../../images/user/i_disease_01_off.svg';
import diabetes from '../../../../images/user/i_disease_02.svg';
import diabetesOff from '../../../../images/user/i_disease_02_off.svg';
import bloodPressure from '../../../../images/user/i_disease_03.svg';
import bloodPressureOff from '../../../../images/user/i_disease_03_off.svg';
import tuberculosis from '../../../../images/user/i_disease_04.svg';
import tuberculosisOff from '../../../../images/user/i_disease_04_off.svg';
import hepatitis from '../../../../images/user/i_disease_05.svg';
import hepatitisOff from '../../../../images/user/i_disease_05_off.svg';
import hyperlipidemia from '../../../../images/user/i_disease_06.svg';
import hyperlipidemiaOff from '../../../../images/user/i_disease_06_off.svg';

import { ReactComponent as AvatarMenIcon } from '../../../../images/common/i_avatar_men.svg'
import { ReactComponent as AvatarWomanIcon } from '../../../../images/common/i_3d_avatar_women.svg'

import familyImg01Icon from '../../../../images/user/i_3d_family_01.svg'
import familyImg02Icon from '../../../../images/user/i_3d_family_02.svg'
import familyImg03Icon from '../../../../images/user/i_3d_family_03.svg'
import familyImg04Icon from '../../../../images/user/i_3d_family_04.svg'

import btnGraph from '../../../../images/common/btn_graph.svg';
import arrowUp from '../../../../images/common/i_arrow_up.svg';
import arrowDown from '../../../../images/common/i_arrow_down.svg';

import pill01 from '../../../../images/user/i_pill_01.svg';
import pill02 from '../../../../images/user/i_pill_02.svg';
import pill03 from '../../../../images/user/i_pill_03.svg';
import pillOff from '../../../../images/user/i_pill_off.svg';

import html2canvas from 'html2canvas';

import ToastPopup from '../../../../components/comm/ToastPopup';

const isExternalUrl = (href) => {
    if (!href || href.startsWith('data:') || href.startsWith('blob:')) return false;
    try {
        const u = new window.URL(href, window.location.href);
        return u.origin !== window.location.origin;
    } catch {
        return /^https?:\/\//i.test(href) && !href.startsWith(window.location.origin);
    }
};

const SummarySkeleton = () => (
    <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {[1, 2, 3].map((i) => (
            <div key={i} style={{
                background: '#e9ecf2',
                borderRadius: '12px',
                height: '160px',
                animation: 'pulse 1.5s ease-in-out infinite',
            }} />
        ))}
        <style>{`
            @keyframes pulse {
                0%, 100% { opacity: 1; }
                50% { opacity: 0.5; }
            }
        `}</style>
    </div>
);


const MyDataSummary = ({ mediInfo, srvrSyncDt }) => {

    const location = useLocation();

    const PROXY_PATH = '/v1/mypage/html2canvas-proxy';

    const loginUser = (() => {
        try {
            return JSON.parse(sessionStorage.getItem("loginUser")) || {};
        } catch {
            return {};
        }
    })();

    const navigate = useNavigate();

    /******************************** useState ********************************/
    const [isLoading, setIsLoading] = useState(true);
    const [usrHsptlMap, setUsrHsptlMap] = useState([]);
    const [isUpdateCompleteMsg, setIsUpdateCompleteMsg] = useState('업데이트가 완료되었어요!');

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [isUpdateOpen, setIsUpdateOpen] = useState(false);
    const [isUpdateLoadingOpen, setIsUpdateLoadingOpen] = useState(false);
    const [isCompleteOpen, setIsCompleteOpen] = useState(false);

    const [downloadOpen, setDownloadOpen] = useState(false);
    const [downloadLoadingOpen, setDownloadLoadingOpen] = useState(false);
    const [downloadCompleteOpen, setDownloadCompleteOpen] = useState(false);

    const [open, setOpen] = useState(false);
    const [openGraph, setOpenGraph] = useState(false);
    const [infoNum, setInfoNum] = useState(1);

    const [summaryViewInfo, setSummaryViewInfo] = useState(null);

    const [pastMediHist, setPastMediHist] = useState({});
    const [dgnssList, setDgnssList] = useState({});
    const [dgnssListCnt, setDgnssListCnt] = useState(0);
    const [examRsltList, setExamRsltList] = useState([]);
    const [examRsltListCnt, setExamRsltListCnt] = useState(0);
    const [targetExamRsltList, setTargetExamRsltList] = useState({
        title: "",
        data: [],
        range: []
    });
    const [doctorList, setDoctorList] = useState([]);
    const [doctorListCnt, setDoctorListCnt] = useState(0);

    const [rotate, setRotate] = useState('');

    /******************************** useCallback ********************************/
    const retrieveSummaryViewInfo = useCallback(async () => {

        const url = "/mypage/retrieveSummaryViewInfo";
        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            },
        }

        await axiosApi.post(url, {}, reqOptions)
            .then((res) => {
                if (res.data.resultCode === CODE.RCV_SUCCESS) {
                    setSummaryViewInfo({ ...res.data.result.result })
                } else {
                    setToastMessage(res.data.resultMessage);
                    setToast(true);
                }
            })
            .catch(err => {
                console.error("요약정보 호출 중 오류  : ", err);
            })

    }, []);

    const retrieveSummaryInfo = useCallback(async () => {

        const url = "/mypage/retrieveSummaryInfo";
        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            },
        }
        await axiosApi.post(url, {}, reqOptions)
            .then((res) => {
                if (res.data.resultCode === CODE.RCV_SUCCESS) {
                    setPastMediHist({ ...res.data.result.pastMediHist });
                    setDgnssList([...res.data.result.dgnssList]);
                    setDgnssListCnt(res.data.result.dgnssListCnt);
                    setExamRsltList([...res.data.result.examRsltList]);
                    setExamRsltListCnt(res.data.result.examRsltListCnt);
                    setDoctorList([...res.data.result.doctorList]);
                    setDoctorListCnt(res.data.result.doctorListCnt);
                } else {
                    setToastMessage(res.data.resultMessage);
                    setToast(true);
                }
            })
            .catch(err => {
                console.error("요약정보 호출 중 오류  : ", err);
            })

    }, []);

    const retrieveTargetExamRsltList = useCallback(async (title, range, hsptlCd, prscrptnTestCd) => {

        const url = "/mypage/retrieveTargetExamRsltList";
        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            },
        }
        await axiosApi.post(url, { hsptlCd: hsptlCd, prscrptnTestCd: prscrptnTestCd }, reqOptions)
            .then((res) => {
                if (res.data.resultCode === CODE.RCV_SUCCESS) {
                    setTargetExamRsltList((prev) => ({ ...prev, title: title, range: range, data: res.data.result.targetExamRsltList }));
                    handleClickOpenGraph();
                } else {
                    setToastMessage(res.data.resultMessage);
                    setToast(true);
                }
            })
            .catch(err => {
                console.error("타겟 주요검사 결과 호출 중 오류  : ", err);
            })

    }, []);

    const updateLoading = useCallback(async () => {
        setIsUpdateOpen(false);
        setIsUpdateLoadingOpen((prev) => !prev);

        const maxLoadingTime = 7000;
        const hospitalLoadingTime = maxLoadingTime / usrHsptlMap.length;

        const lastIndex = usrHsptlMap.length - 1;
        let updateTimerList = [];

        usrHsptlMap.forEach((_, index) => {
            if (index === lastIndex) return;
            const timer = setTimeout(() => {
                setUsrHsptlMap((prev) => {
                    const updated = [...prev];
                    updated[index] = { ...updated[index], isUpdate: true };
                    return updated;
                });
            }, hospitalLoadingTime * (index + 1));
            updateTimerList.push(timer);
        });

        const url = "/mypage/updateMyHsptInfo";
        const jToken = localStorage.getItem("jToken");

        const reqOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            },
            noLoading: true,
        }

        const startTime = Date.now();

        axiosApi.post(url, {}, reqOptions)
            .then((res) => {
                const elapsed = Date.now() - startTime;

                if (res.data.resultCode === CODE.RCV_SUCCESS) {
                    setIsUpdateCompleteMsg('업데이트가 완료되었어요!');
                    if (elapsed >= maxLoadingTime) {
                        setUsrHsptlMap((prev) => {
                            const updated = [...prev];
                            updated[lastIndex] = { ...updated[lastIndex], isUpdate: true };
                            return updated;
                        });
                        setTimeout(() => {
                            cleanupAndFinish();
                        }, 500);
                    } else {
                        updateTimerList.forEach(clearTimeout);
                        setUsrHsptlMap((prev) =>
                            prev.map((item) => ({ ...item, isUpdate: true }))
                        );
                        setTimeout(() => {
                            cleanupAndFinish();
                        }, 500);
                    }
                } else {
                    setIsUpdateCompleteMsg('앗! 업데이트를 실패했어요.\n다시 시도 해주세요.');
                    cleanupAndFinish();
                }
            })
            .catch((err) => {
                console.error("병원정보 업데이트 중 오류:", err);
                setIsUpdateCompleteMsg('앗! 업데이트를 실패했어요.\n다시 시도 해주세요.');
                cleanupAndFinish();
            });

        const cleanupAndFinish = () => {
            updateTimerList.forEach(clearTimeout);
            setIsUpdateLoadingOpen(false);
            loadingComplete();

            setUsrHsptlMap((prev) =>
                prev.map((item) => ({ ...item, isUpdate: false }))
            );
        }

    }, [usrHsptlMap])

    /******************************** useEffect ********************************/
    useEffect(() => {
        
        let cancelled = false;

        setUsrHsptlMap(
            (loginUser.usrHsptlMap || []).map((item) => ({
                hsptlSortOrdr: item.hsptlSortOrdr,
                cnncPatntNo: item.cnncPatntNo,
                cnncHsptlCd: item.cnncHsptlCd,
                cnncHsptlNm: item.cnncHsptlNm,
                isUpdate: false,
            }))
        );

       // 1. window.history를 사용하여 브라우저의 자동 스크롤 복원 비활성화
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }

        // 2. 뒤로가기 시 무조건 맨 위로 스크롤 고정
        window.scrollTo(0, 0);

      const fetchData = async () => {
        // 수정: 기존 데이터가 없을 때만 스켈레톤 로딩을 보여줌
        if (!summaryViewInfo) {
            setIsLoading(true); 
        }
        
        try {
            await retrieveSummaryViewInfo();
            if (!cancelled) await retrieveSummaryInfo();
        } finally {
            if (!cancelled) setIsLoading(false);
        }
    };

        fetchData();
        return () => { cancelled = true; };
    }, [location.key]);

    useEffect(() => {
        const timer = setTimeout(() => setRotate(''), 3000);
        return () => clearTimeout(timer);
    }, [rotate]);

    /******************************** Event ********************************/
    const handleClickOpenGraph = () => {
        setOpenGraph(true);
    }

    const handleClickDoctor = (deptCd, deptNm, hsptlCd, doctrNo, doctrNm, nuHsptlJbpt, nuSchulJbpt, nuEtcJbpt, nuClnicField) => {
        navigate(URL.HOSPITAL_DOCTORDETAIL, {
            state: {
                deptCd: deptCd,
                deptNm: deptNm,
                hosptlCd: hsptlCd,
                doctNo: doctrNo,
                docName: doctrNm,
                hosJbpt: nuHsptlJbpt,
                schJbpt: nuSchulJbpt,
                etcJbpt: nuEtcJbpt,
                docField: nuClnicField,
            }
        });
    }

    function onDismiss() {
        setOpen(false);
    }

    function onGraphDismiss() {
        setOpenGraph(false);
    }

    const refreshBtn = (srvrSyncDt) => {
        setRotate('on');
        setIsUpdateOpen(!isUpdateOpen);
    }

    const loadingComplete = () => {
        setIsUpdateLoadingOpen(false);
        setIsCompleteOpen((prev) => !prev);
    }

    const downloadComplete = () => {
        setDownloadLoadingOpen(false);
        setDownloadCompleteOpen(!downloadCompleteOpen)
    }

    const toProxy = (absUrl) => `${PROXY_PATH}?url=${encodeURIComponent(absUrl)}`;

    const makeOffscreenClone = (el) => {
        const clone = el.cloneNode(true);
        clone.id = 'pdfContainer-clone';
        clone.style.position = 'fixed';
        clone.style.left = '-100000px';
        clone.style.top = '0';
        clone.style.pointerEvents = 'none';
        clone.style.opacity = '1';
        document.body.appendChild(clone);
        return clone;
    };

    const toBase64 = async (url) => {
        try {
            const res = await fetch(toProxy(url));
            if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
            const blob = await res.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (err) {
            console.error('Failed to convert to Base64:', url, err);
            return '';
        }
    };

    const waitForImageLoad = (img) => {
        return new Promise((resolve) => {
            if (img.complete && img.naturalWidth !== 0) {
                resolve();
            } else {
                img.onload = () => resolve();
                img.onerror = () => resolve();
            }
        });
    };

    const waitForAllImagesLoaded = async (element) => {
        const images = element.querySelectorAll('img');
        const imagePromises = Array.from(images).map(img => waitForImageLoad(img));
        await Promise.all(imagePromises);
    };

    const rewriteCloneImagesToBase64 = async (cloneRoot) => {
        const images = cloneRoot.querySelectorAll('img');

        for (const img of images) {
            const src = img.getAttribute('src') || img.src;
            if (!src) continue;

            try {
                const u = new URL(src, window.location.href);
                if (u.origin !== window.location.origin) {
                    const base64 = await toBase64(u.href);
                    if (base64) {
                        img.setAttribute('src', base64);
                        await waitForImageLoad(img);
                    }
                } else {
                    await waitForImageLoad(img);
                }
            } catch (e) {
                console.error('Failed to convert image to Base64', e);
            }
        }
    };

    const rewriteCloneCssUrlsToProxy = async (origRoot, cloneRoot) => {
        const origEls = origRoot.querySelectorAll('*');
        const cloneEls = cloneRoot.querySelectorAll('*');
        const PROPS = [
            'background-image',
            'mask-image',
            '-webkit-mask-image',
            'border-image-source',
            'list-style-image',
        ];

        const promises = [];

        for (let i = 0; i < cloneEls.length; i++) {
            const el = cloneEls[i];
            const cs = window.getComputedStyle(origEls[i]);

            PROPS.forEach((prop) => {
                const val = cs.getPropertyValue(prop);
                if (!val) return;
                const m = val.match(/url\((['"]?)(.+?)\1\)/);
                if (!m) return;

                const url = m[2];
                try {
                    const u = new URL(url, window.location.href);
                    if (u.origin !== window.location.origin) {
                        const promise = toBase64(u.href).then((base64Data) => {
                            if (base64Data) {
                                el.style.setProperty(prop, `url("${base64Data}")`, 'important');
                                return new Promise(resolve => setTimeout(resolve, 100));
                            }
                        });
                        promises.push(promise);
                    }
                } catch { }
            });
        }

        await Promise.all(promises);
    };

    const materializePseudosToInline = async (origRoot, cloneRoot) => {
        const origEls = origRoot.querySelectorAll('*');
        const cloneEls = cloneRoot.querySelectorAll('*');

        const promises = [];

        const copy = (origEl, cloneEl, pseudo) => {
            const cs = window.getComputedStyle(origEl, pseudo);
            const bg = cs.getPropertyValue('background-image');
            const hasBg = !!bg && bg.includes('url(');
            const content = cs.getPropertyValue('content');

            if (!hasBg && (!content || content === 'none')) return;

            let proxiedBg = '';
            if (hasBg) {
                const m = bg.match(/url\((['"]?)(.+?)\1\)/);
                if (m) {
                    try {
                        const u = new URL(m[2], window.location.href);
                        const isExternal = u.origin !== window.location.origin;

                        const promise = (isExternal ? toBase64(u.href) : Promise.resolve(u.href))
                            .then((result) => {
                                if (!result) return;
                                proxiedBg = `url("${result}")`;

                                const span = document.createElement('span');
                                span.setAttribute('data-pseudo', pseudo);
                                const clonePos = window.getComputedStyle(cloneEl).getPropertyValue('position');
                                if (clonePos === 'static') cloneEl.style.position = 'relative';
                                span.style.position = 'absolute';
                                span.style.pointerEvents = 'none';
                                span.style.display = 'block';

                                ['top', 'left', 'right', 'bottom', 'width', 'height', 'transform', 'opacity', 'z-index',
                                    'background-position', 'background-size', 'background-repeat'].forEach((p) => {
                                        const v = cs.getPropertyValue(p);
                                        if (v) span.style.setProperty(p, v);
                                    });

                                if (proxiedBg) span.style.backgroundImage = proxiedBg;

                                if (content && content !== 'none') {
                                    span.textContent = content.replace(/^"(.*)"$/, '$1');
                                }

                                if (pseudo === '::before') cloneEl.prepend(span);
                                else cloneEl.appendChild(span);

                                return new Promise(resolve => setTimeout(resolve, 50));
                            })
                            .catch(err => console.error('Pseudo element Base64 conversion failed:', err));

                        promises.push(promise);
                    } catch { }
                }
            }
        };

        for (let i = 0; i < cloneEls.length; i++) {
            copy(origEls[i], cloneEls[i], '::before');
            copy(origEls[i], cloneEls[i], '::after');
        }

        await Promise.all(promises);

        const styleEl = document.createElement('style');
        styleEl.textContent = `*::before,*::after{ content:none !important; }`;
        cloneRoot.prepend(styleEl);
    };

    const rewriteInlineSvgLinksToProxy = async (cloneRoot) => {
        const XLINK_NS = 'http://www.w3.org/1999/xlink';
        const els = cloneRoot.querySelectorAll('image, use, feImage, pattern image');

        const promises = [];

        els.forEach((el) => {
            const raw =
                el.getAttribute('href') ||
                el.getAttributeNS?.(XLINK_NS, 'href') ||
                el.getAttribute('xlink:href');

            if (!raw) return;

            try {
                const u = new URL(raw, window.location.href);
                if (u.origin !== window.location.origin) {
                    const promise = toBase64(u.href).then((proxied) => {
                        if (proxied) {
                            el.setAttribute('href', proxied);
                            try { el.setAttributeNS(XLINK_NS, 'href', proxied); } catch { }
                            el.setAttribute('xlink:href', proxied);
                        }
                    }).catch(err => console.error('SVG href Base64 conversion failed:', err));
                    promises.push(promise);
                }
            } catch { }
        });

        await Promise.all(promises);
    };

    const convertDataIconsToImages = async (cloneRoot) => {
        const dataIconElements = cloneRoot.querySelectorAll('[data-icon]');

        const promises = Array.from(dataIconElements).map(async (element) => {
            const iconNumber = element.getAttribute('data-icon');
            if (!iconNumber) return;

            const computedStyle = window.getComputedStyle(element, '::before');
            const backgroundImage = computedStyle.getPropertyValue('background-image');

            if (!backgroundImage || backgroundImage === 'none') {
                const afterStyle = window.getComputedStyle(element, '::after');
                const afterBackgroundImage = afterStyle.getPropertyValue('background-image');

                if (!afterBackgroundImage || afterBackgroundImage === 'none') {
                    const elementStyle = window.getComputedStyle(element);
                    const elementBg = elementStyle.getPropertyValue('background-image');

                    if (elementBg && elementBg !== 'none') {
                        await replaceWithActualImage(element, elementBg);
                    }
                    return;
                }
                await replaceWithActualImage(element, afterBackgroundImage, '::after');
                return;
            }

            await replaceWithActualImage(element, backgroundImage, '::before');
        });

        await Promise.all(promises);
    };

    const replaceWithActualImage = async (element, backgroundImage, pseudoElement = null) => {
        const urlMatch = backgroundImage.match(/url\(['"]?([^'"]*)['"]?\)/);
        if (!urlMatch) return;

        let imageUrl = urlMatch[1];

        try {
            const u = new URL(imageUrl, window.location.href);
            if (u.origin !== window.location.origin) {
                imageUrl = await toBase64(u.href);
                if (!imageUrl) return;
            }

            const img = document.createElement('img');
            img.src = imageUrl;
            img.style.display = 'block';
            img.style.width = '100%';
            img.style.height = '100%';
            img.style.objectFit = 'contain';

            if (pseudoElement) {
                const pseudoStyle = window.getComputedStyle(element, pseudoElement);
                img.style.width = pseudoStyle.getPropertyValue('width');
                img.style.height = pseudoStyle.getPropertyValue('height');
                img.style.position = pseudoStyle.getPropertyValue('position');
                img.style.top = pseudoStyle.getPropertyValue('top');
                img.style.left = pseudoStyle.getPropertyValue('left');
                img.style.right = pseudoStyle.getPropertyValue('right');
                img.style.bottom = pseudoStyle.getPropertyValue('bottom');
            } else {
                const elementStyle = window.getComputedStyle(element);
                if (elementStyle.getPropertyValue('width') !== 'auto') {
                    img.style.width = elementStyle.getPropertyValue('width');
                }
                if (elementStyle.getPropertyValue('height') !== 'auto') {
                    img.style.height = elementStyle.getPropertyValue('height');
                }
            }

            await waitForImageLoad(img);

            element.appendChild(img);
            element.style.backgroundImage = 'none';

            if (pseudoElement) {
                const hideStyle = document.createElement('style');
                hideStyle.textContent = `
                [data-icon="${element.getAttribute('data-icon')}"]${pseudoElement} {
                    background-image: none !important;
                    content: none !important;
                }
            `;
                element.appendChild(hideStyle);
            }

        } catch (error) {
            console.error('배경 이미지 변환 실패:', error);
        }
    };

    const handleDownload = async () => {
        try {
            setDownloadOpen(false);
            setDownloadLoadingOpen(true);

            const container = document.getElementById('pdfContainer');

            const clone = makeOffscreenClone(container);

            console.log('data-icon 요소 처리 시작...');
            await convertDataIconsToImages(clone);

            console.log('이미지 변환 시작...');
            await rewriteCloneImagesToBase64(clone);
            console.log('CSS 배경 이미지 처리 시작...');
            await rewriteCloneCssUrlsToProxy(container, clone);
            console.log('가상 요소 처리 시작...');
            await materializePseudosToInline(container, clone);
            console.log('SVG 링크 처리 시작...');
            await rewriteInlineSvgLinksToProxy(clone);

            console.log('모든 이미지 로딩 완료 대기...');
            await waitForAllImagesLoaded(clone);

            await new Promise(resolve => setTimeout(resolve, 800));

            console.log('html2canvas 캡처 시작...');
            const canvas = await html2canvas(clone, {
                useCORS: false,
                allowTaint: false,
                backgroundColor: '#fff',
                scale: Math.min(1.5, window.devicePixelRatio || 1),
                windowWidth: clone.scrollWidth,
                windowHeight: clone.scrollHeight,
                logging: true,
                onclone: (clonedDoc) => {
                    console.log('html2canvas clone 완료');
                    const dataIcons = clonedDoc.querySelectorAll('[data-icon]');
                    console.log(`data-icon 요소 ${dataIcons.length}개 발견`);

                    dataIcons.forEach((el, index) => {
                        const img = el.querySelector('img');
                        if (img) {
                            console.log(`data-icon ${index}: 이미지 변환 완료`);
                        } else {
                            console.warn(`data-icon ${index}: 이미지 변환 실패`);
                        }
                    });

                    const images = clonedDoc.querySelectorAll('img');
                    images.forEach((img, index) => {
                        if (!img.complete || img.naturalWidth === 0) {
                            console.warn(`Image ${index} not loaded:`, img.src);
                        }
                    });
                }
            });

            console.log('캔버스 생성 완료, 크기:', canvas.width, 'x', canvas.height);

            try { document.body.removeChild(clone); } catch { }

            const jToken = localStorage.getItem('jToken');
            const pdfPassword = (mediInfo?.brthdy || '').replace(/\D/g, '').slice(-6) || '000000';

            const res = await axiosApi.post(
                '/mypage/stagePdf',
                {
                    images: [canvas.toDataURL('image/png')],
                    password: pdfPassword,
                    filename: `MyData_${new Date().toISOString().slice(0, 19).replace(/[-:T]/g, '')}.pdf`,
                },
                { headers: { Authorization: `Bearer ${jToken}` }, noLoading: true }
            );

            if (res.data.resultCode !== CODE.RCV_SUCCESS) {
                setToastMessage(res.data.resultMessage || 'PDF 생성 실패');
                setToast(true);
                setDownloadLoadingOpen(false);
                return;
            }

            const token = res.data.result.result.token;
            const filename = res.data.result.result.filename;

            const apiBase = (axiosApi?.defaults?.baseURL || '').replace(/\/$/, '');
            const absUrl = `${apiBase}/mypage/downloadPdfFile?token=${encodeURIComponent(token)}`;

            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(JSON.stringify({
                    type: 'DOWNLOAD_URL',
                    url: absUrl,
                    filename: filename || 'MyData.pdf',
                    mime: 'application/pdf',
                }));
                setDownloadLoadingOpen(false);
                setDownloadCompleteOpen(true);
                return;
            }

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = absUrl;
            document.body.appendChild(iframe);
            setDownloadLoadingOpen(false);
            setDownloadCompleteOpen(true);
            setTimeout(() => { try { document.body.removeChild(iframe); } catch { } }, 60000);

        } catch (err) {
            alert(err)
            console.error('다운로드 오류:', err);
            setToastMessage('다운로드 중 오류가 발생했습니다.');
            setToast(true);
            setDownloadLoadingOpen(false);
        }
    };

    return (
        <>
            <div className={style['content-box']} id="pdfContainer" style={{ backgroundColor: "#F4F6FA" }}>
                <div className={style['update-box']}>
                    <p>
                        <span>최근 업데이트</span>
                        <span>{srvrSyncDt}</span>
                    </p>
                    <button className={style['re-fresh-btn']} data-refresh={rotate} onClick={() => { refreshBtn(srvrSyncDt) }}></button>
                </div>

                <div className='inner-wrap' data-pad-type="c">

                    {isLoading || !summaryViewInfo ? (
                        <SummarySkeleton />
                    ) : (
                        <>
                            {/* 기본 정보:: S */}
                            {summaryViewInfo.bassInfoAt === '1' &&
                                <div className={style['content-box']}>
                                    <div className={style['title-box']}>
                                        <div className={style['left']}>
                                            <p>기본 정보</p>
                                        </div>
                                        <div className={style['right']}>
                                            <button className='btn' data-btn-type="fill-gray-dark" data-btn-size='sm' onClick={() => navigate(URL.BASIC_INFO_WRITE, { state: { mediInfo: mediInfo } })}>
                                                <span>수정하기</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div className={style['content']}>
                                        <div className={style['profile-box']}>
                                            <div className={style['avatar-box']}>
                                                <div className={style['avatar-img']} aria-hidden='true'>
                                                    {mediInfo.gendr ? mediInfo.gendr === '1' ? <AvatarMenIcon /> : <AvatarWomanIcon /> : <AvatarMenIcon />}
                                                </div>
                                                <p><b>{mediInfo.usrNm}</b> 님</p>
                                            </div>
                                            <div className={style['privacy-box']}>
                                                <div className={style['table-box']}>
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <th>생년월일</th>
                                                                <td>
                                                                    <div className={style['txt-box']}>
                                                                        <span>{mediInfo.brthdy} ({mediInfo.age}세)</span>
                                                                        <span>{mediInfo.gendr ? mediInfo.gendr === '1' ? '남성' : '여성' : ''}</span>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th>신체정보</th>
                                                                <td>
                                                                    <div className={style['txt-box']}>
                                                                        <span>{mediInfo.height}cm</span>
                                                                        <span>{mediInfo.bdwgh}kg</span>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th>혈액형</th>
                                                                <td>
                                                                    <div className={style['txt-box']}>
                                                                        <span>{mediInfo.bdpRh} {mediInfo.bdpAbo}</span>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            {loginUser.gendr !== '1' &&
                                                                <tr>
                                                                    <th>임신가능성</th>
                                                                    <td>
                                                                        <div className={style['txt-box']}>
                                                                            <span>{mediInfo.prgncPsblAt === '0' ? '없음' : mediInfo.prgncPsblAt === '1' ? '있음' : mediInfo.prgncPsblAt === '2' ? '현재 임신중입니다' : ''}</span>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            }
                                                            <tr>
                                                                <th>장기기증자</th>
                                                                <td>
                                                                    <div className={style['txt-box']}>
                                                                        <span>{mediInfo.inorgCntrAt === '0' ? '미해당' : '해당'}</span>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {/* 기본 정보:: E */}


                            {/* 알레르기:: S */}
                            {summaryViewInfo.alrgyExprsAt === '1' &&
                                <div className={style['content-box']}>
                                    <div className={style['title-box']}>
                                        <div className={style['left']}>
                                            <p>알레르기</p>
                                        </div>
                                        <div className={style['right']}>
                                            <span className={style['txt-date']}>{mediInfo.alrgyWrtDt} 기준</span>
                                            <button className='btn' data-btn-type="fill-gray-dark" data-btn-size='sm' onClick={() => { navigate(URL.ALLERGY_LIST_WRITE, { state: { mediInfo: mediInfo } }) }}>
                                                <span>수정하기</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div className={style['content']}>
                                        <div className={style['allergy-box']}>
                                            <div className={style['in-box']}>
                                                <p>{mediInfo.alrgyCn ? mediInfo.alrgyCn : "알레르기 정보가 없습니다."}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {/* 알레르기:: E */}

                            {/* 과거력:: S */}
                            {summaryViewInfo.hxExprsAt === '1' &&
                                <div className={style['content-box']}>
                                    <div className={style['title-box']}>
                                        <div className={style['left']}>
                                            <p>과거력</p>
                                        </div>
                                        <div className={style['right']}>
                                            <span className={style['txt-date']}>{mediInfo.hxWrtDt} 기준</span>
                                            <button className='btn' data-btn-type="fill-gray-dark" data-btn-size='sm' onClick={() => navigate(URL.PAST_HISTORY_WRITE, { state: { mediInfo: mediInfo } })}>
                                                <span>수정하기</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div className={style['content']}>
                                        <div className={style['past-history-box']}>
                                            <ul>
                                                <li data-status={mediInfo.cancrDgnssAt !== '1' ? 'off' : ''}>
                                                    <div className={style['icon-box']}>
                                                        <img
                                                            src={mediInfo.cancrDgnssAt === '1' ? cancer : cancerOff}
                                                            alt="암"
                                                            style={{ width: '32px', height: '32px' }}
                                                        />
                                                    </div>
                                                    <p>암</p>
                                                </li>
                                                <li data-status={mediInfo.dabtsDgnssAt !== '1' ? 'off' : ''}>
                                                    <div className={style['icon-box']}>
                                                        <img
                                                            src={mediInfo.dabtsDgnssAt === '1' ? diabetes : diabetesOff}
                                                            alt="당뇨"
                                                            style={{ width: '32px', height: '32px' }}
                                                        />
                                                    </div>
                                                    <p>당뇨</p>
                                                </li>
                                                <li data-status={mediInfo.hhprsDgnssAt !== '1' ? 'off' : ''}>
                                                    <div className={style['icon-box']}>
                                                        <img
                                                            src={mediInfo.hhprsDgnssAt === '1' ? bloodPressure : bloodPressureOff}
                                                            alt="고혈압"
                                                            style={{ width: '32px', height: '32px' }}
                                                        />
                                                    </div>
                                                    <p>고혈압</p>
                                                </li>
                                                <li data-status={mediInfo.tbrclDgnssAt !== '1' ? 'off' : ''}>
                                                    <div className={style['icon-box']}>
                                                        <img
                                                            src={mediInfo.tbrclDgnssAt === '1' ? tuberculosis : tuberculosisOff}
                                                            alt="결핵"
                                                            style={{ width: '32px', height: '32px' }}
                                                        />
                                                    </div>
                                                    <p>결핵</p>
                                                </li>
                                                <li data-status={mediInfo.hrtsDgnssAt !== '1' ? 'off' : ''}>
                                                    <div className={style['icon-box']}>
                                                        <img
                                                            src={mediInfo.hrtsDgnssAt === '1' ? hepatitis : hepatitisOff}
                                                            alt="간염"
                                                            style={{ width: '32px', height: '32px' }}
                                                        />
                                                    </div>
                                                    <p>간염</p>
                                                </li>
                                                <li data-status={mediInfo.hypldDgnssAt !== '1' ? 'off' : ''}>
                                                    <div className={style['icon-box']}>
                                                        <img
                                                            src={mediInfo.hypldDgnssAt === '1' ? hyperlipidemia : hyperlipidemiaOff}
                                                            alt="이상지질혈증"
                                                            style={{ width: '32px', height: '32px' }}
                                                        />
                                                    </div>
                                                    <p>이상지질혈증
                                                        <span>(고지혈증)</span>
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            }
                            {/* 과거력:: E */}


                            {/* 가족력:: S */}
                            {summaryViewInfo.fhExprsAt === '1' &&
                                <div className={style['content-box']}>
                                    <div className={style['title-box']}>
                                        <div className={style['left']}>
                                            <p>가족력</p>
                                        </div>
                                        <div className={style['right']}>
                                            <span className={style['txt-date']}>{mediInfo.fhWrtDt} 기준</span>
                                            <button className='btn' data-btn-type="fill-gray-dark" data-btn-size='sm' onClick={() => navigate(URL.FAMILY_HISTORY_WRITE, { state: { mediInfo: mediInfo } })}>
                                                <span>수정하기</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div className={style['content']}>
                                        <div className={style['family-list-box']}>
                                            <ul>
                                                <li data-icon="1">
                                                    <div className={style['left']}>
                                                        <img src={familyImg01Icon} />
                                                    </div>
                                                    <div className={style['right']}>
                                                        <p>아버지</p>
                                                        <span>{mediInfo.fathrFhCn ? mediInfo.fathrFhCn : "가족력 정보가 없습니다."}</span>
                                                    </div>
                                                </li>
                                                <li data-icon="2">
                                                    <div className={style['left']}>
                                                        <img src={familyImg02Icon} />
                                                    </div>
                                                    <div className={style['right']}>
                                                        <p>어머니</p>
                                                        <span>{mediInfo.mothrFhCn ? mediInfo.mothrFhCn : "가족력 정보가 없습니다."}</span>
                                                    </div>
                                                </li>
                                                <li data-icon="3">
                                                    <div className={style['left']}>
                                                        <img src={familyImg03Icon} />
                                                    </div>
                                                    <div className={style['right']}>
                                                        <p>조부, 조모, 외조부, 외조모</p>
                                                        <span>{mediInfo.mtrprntFhCn ? mediInfo.mtrprntFhCn : "가족력 정보가 없습니다."}</span>
                                                    </div>
                                                </li>
                                                <li data-icon="4">
                                                    <div className={style['left']}>
                                                        <img src={familyImg04Icon} />
                                                    </div>
                                                    <div className={style['right']}>
                                                        <p>형제, 자매</p>
                                                        <span>{mediInfo.brtssFhCn ? mediInfo.brtssFhCn : "가족력 정보가 없습니다."}</span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            }
                            {/* 가족력:: E */}


                            {/* 주요 약물력:: S */}
                            {summaryViewInfo.mainMdcnAt === '1' &&
                                <div className={style['content-box']}>
                                    <style>
                                        {`
                                            div[class*="content-box"] div[class*="medication-box"] ul li::before {
                                                display: none !important;
                                            }
                                        `}
                                    </style>
                                    <div className={style['title-box']}>
                                        <div className={style['left']}>
                                            <p>주요 약물력</p>
                                        </div>
                                        <div className={style['right']}>
                                            <span className={style['txt-date']}>{srvrSyncDt ? srvrSyncDt.substr(2) : ''} 기준</span>
                                        </div>
                                    </div>

                                    <div className={style['content']}>
                                        <div className={style['medication-box']}>
                                            <ul>
                                                <li data-pill={pastMediHist.steroidMedicationCnt > 0 ? "2" : "off"}>
                                                    <div className={style['pill-icon']}>
                                                        <img
                                                            src={pastMediHist.steroidMedicationCnt > 0 ? pill01 : pillOff}
                                                            alt="스테로이드제"
                                                            style={{ width: '32px', height: '32px' }}
                                                        />
                                                    </div>
                                                    <p>스테로이드제</p>
                                                    <p className={style['span-box']}>
                                                        <span>최근 1년간</span>
                                                        <span>처방이력 {pastMediHist.steroidMedicationCnt > 0 ? "있음" : "없음"}</span>
                                                    </p>
                                                    <button
                                                        className={style['btn-box']}
                                                        disabled={pastMediHist.steroidMedicationCnt > 0 ? false : true}
                                                        onClick={() => { navigate(URL.MEDICATION_MORE, { state: { prscrptnGbn: "1" } }) }}
                                                    >
                                                        <span>상세보기</span>
                                                    </button>
                                                </li>

                                                <li data-pill={pastMediHist.antithromboticUseCnt > 0 ? "2" : "off"}>
                                                    <div className={style['pill-icon']}>
                                                        <img
                                                            src={pastMediHist.antithromboticUseCnt > 0 ? pill02 : pillOff}
                                                            alt="항혈전제"
                                                            style={{ width: '32px', height: '32px' }}
                                                        />
                                                    </div>
                                                    <p>항혈전제</p>
                                                    <p className={style['span-box']}>
                                                        <span>최근 1년간</span>
                                                        <span>처방이력 {pastMediHist.antithromboticUseCnt > 0 ? "있음" : "없음"}</span>
                                                    </p>
                                                    <button
                                                        className={style['btn-box']}
                                                        disabled={pastMediHist.antithromboticUseCnt > 0 ? false : true}
                                                        onClick={() => { navigate(URL.MEDICATION_MORE, { state: { prscrptnGbn: "2" } }) }}
                                                    >
                                                        <span>상세보기</span>
                                                    </button>
                                                </li>

                                                <li data-pill={pastMediHist.psychotropicUseCnt > 0 ? "2" : "off"}>
                                                    <div className={style['pill-icon']}>
                                                        <img
                                                            src={pastMediHist.psychotropicUseCnt > 0 ? pill03 : pillOff}
                                                            alt="향정신제"
                                                            style={{ width: '32px', height: '32px' }}
                                                        />
                                                    </div>
                                                    <p>향정신제</p>
                                                    <p className={style['span-box']}>
                                                        <span>최근 1년간</span>
                                                        <span>처방이력 {pastMediHist.psychotropicUseCnt > 0 ? "있음" : "없음"}</span>
                                                    </p>
                                                    <button
                                                        className={style['btn-box']}
                                                        disabled={pastMediHist.psychotropicUseCnt > 0 ? false : true}
                                                        onClick={() => { navigate(URL.MEDICATION_MORE, { state: { prscrptnGbn: "3" } }) }}
                                                    >
                                                        <span>상세보기</span>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            }
                            {/* 주요 약물력:: E */}


                            {/* 현재 복용중인 약물:: S */}
                            {summaryViewInfo.tkmdcnExprsAt === '1' &&
                                <div className={style['content-box']}>
                                    <div className={style['title-box']}>
                                        <div className={style['left']}>
                                            <p>현재 복용중인 약물</p>
                                        </div>
                                        <div className={style['right']}>
                                            <span className={style['txt-date']}>{mediInfo.mdcnWrtDt} 기준</span>
                                            <button className='btn' data-btn-type="fill-gray-dark" data-btn-size='sm' onClick={() => { navigate(URL.DRUGS_LIST_WRITE, { state: { mediInfo: mediInfo } }) }}>
                                                <span>수정하기</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div className={style['content']}>
                                        <div className={style['drugs-list-box']}>
                                            <ul>
                                                <li>
                                                    <p>처방약</p>
                                                    <div className={style['span-box']}>
                                                        <span>{mediInfo.crrPrscmdcCn ? mediInfo.crrPrscmdcCn : "처방약 정보가 없습니다."}</span>
                                                    </div>
                                                </li>
                                                <li>
                                                    <p>기타 복용약(영양제, 건강기능식품 등)</p>
                                                    <div className={style['span-box']}>
                                                        <span>{mediInfo.etcMdcnCn ? mediInfo.etcMdcnCn : "기타 복용약 정보가 없습니다."}</span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            }
                            {/* 현재 복용중인 약물:: E */}


                            {/* 주요 검사 결과:: S */}
                            {summaryViewInfo.mainTstAt === '1' &&
                                <div className={style['content-box']}>
                                    <div className={style['title-box']}>
                                        <div className={style['left']}>
                                            <p>주요 검사 결과</p>
                                        </div>
                                        <div className={style['right']}>
                                            <span className={style['txt-date']}>{srvrSyncDt ? srvrSyncDt.substr(2) : ''} 기준</span>
                                        </div>
                                    </div>

                                    <div className={style['content']}>
                                        <div className={style["inspection-list-box"]}>
                                            <ul>
                                                {examRsltList.length === 0 &&
                                                    <li className={style['no-data-box']}>
                                                        <span>주요 검사 결과가 없습니다.</span>
                                                    </li>
                                                }

                                                {examRsltList.length > 0 &&
                                                    examRsltList.slice(0, 5).map((item, _idx) => {
                                                        return (
                                                            <li key={_idx}>
                                                                <div className={style["list-box"]}>
                                                                    <div className={style["top-head"]}>
                                                                        {item.isInRef === '-99' ?
                                                                            <span data-status=''></span> :
                                                                            item.isInRef === '0' ?
                                                                                <span data-status='strange'>이상</span> :
                                                                                <span data-status="normal">정상</span>
                                                                        }
                                                                        <div className={style['btns-box']}>
                                                                            <button
                                                                                className={style['graph-more-btn']}
                                                                                onClick={() => {
                                                                                    retrieveTargetExamRsltList(item.testKorNm, [item.refMin, item.refMax], item.hsptlCd, item.prscrptnTestCd)
                                                                                }}
                                                                                style={{
                                                                                    background: 'none',
                                                                                    border: 'none',
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                            >
                                                                                <img
                                                                                    src={btnGraph}
                                                                                    alt="그래프 보기"
                                                                                    style={{ width: '24px', height: '24px' }}
                                                                                />
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <div className={style["head"]}>
                                                                        <p>{item.testKorNm} <span>{item.testEngNm}</span></p>
                                                                    </div>
                                                                    <div className={style["value-box"]}>
                                                                        <strong>{item.prscrptnTestRsltVal} {item.unit}</strong>
                                                                        <p className={style['compar-value']}>
                                                                            (
                                                                            <span>
                                                                                {item.diffVal === 0 && "-"}
                                                                                {item.diffVal !== 0 && item.diffVal && (
                                                                                    <>
                                                                                        {item.diffVal}
                                                                                        <img
                                                                                            src={item.diffVal > 0 ? arrowUp : arrowDown}
                                                                                            alt={item.diffVal > 0 ? "상승" : "하락"}
                                                                                            style={{
                                                                                                width: '12px',
                                                                                                height: '12px',
                                                                                                marginLeft: '4px',
                                                                                                display: 'inline-block'
                                                                                            }}
                                                                                        />
                                                                                    </>
                                                                                )}
                                                                            </span>
                                                                            )
                                                                        </p>
                                                                    </div>
                                                                    <p className={style["details-txt"]}>
                                                                        <span>{item.testKorDesc}</span>
                                                                    </p>
                                                                    <div className={style['span-box']}>
                                                                        <span>{item.prscrptnTestRsltDate}</span>
                                                                        <span>{item.hsptlNm}</span>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                            {examRsltList.length > 5 &&
                                                <button className='btn' data-btn-type="fill-gray-dark" data-btn-size='smd' data-btn-width='full' onClick={() => navigate(URL.INSPECTION_MORE)}>
                                                    <span>{examRsltListCnt}개 더 보기</span>
                                                </button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                            {/* 주요 검사 결과:: E */}


                            {/* 주치의 정보:: S */}
                            {summaryViewInfo.atphsExprsAt === '1' &&
                                <div className={style['content-box']}>
                                    <div className={style['title-box']}>
                                        <div className={style['left']}>
                                            <p>주치의 정보</p>
                                        </div>
                                        <div className={style['right']}>
                                            <span className={style['txt-date']}>{srvrSyncDt ? srvrSyncDt.substr(2) : ''} 기준</span>
                                        </div>
                                    </div>

                                    <div className={style['content']}>
                                        <div className={style['doctor-list-box']}>
                                            <ul>
                                                {doctorList.length === 0 &&
                                                    <li className={style['no-data-box']}>
                                                        <span>주치의 정보가 없습니다.</span>
                                                    </li>
                                                }

                                                {doctorList.length > 0 &&
                                                    doctorList.slice(0, 5).map((item, _idx) => {
                                                        return (
                                                            <li key={_idx} onClick={() => {
                                                                handleClickDoctor(
                                                                    item.deptCd, item.deptNm, item.hsptlCd, item.doctrNo,
                                                                    item.doctrNm, item.nuHsptlJbpt, item.nuSchulJbpt,
                                                                    item.nuEtcJbpt, item.nuClnicField
                                                                )
                                                            }}>
                                                                <div className={style['photo-box']}>
                                                                    {!item.doctrImgUrl ? (
                                                                        <img
                                                                            src={noDoctorImgPng}
                                                                            alt="Doctor"
                                                                        />
                                                                    ) : (
                                                                        <img
                                                                            src={item.doctrImgUrl}
                                                                            alt="Doctor"
                                                                            onError={(e) => {
                                                                                e.target.onerror = null;
                                                                                e.target.src = noDoctorImgPng;
                                                                            }}
                                                                        />
                                                                    )}
                                                                </div>
                                                                <div className={style['info-txt-box']}>
                                                                    <div className={style['span-box']}>
                                                                        <span>{item.hsptlNm}</span>
                                                                        <span>{item.deptNm}</span>
                                                                    </div>
                                                                    <p>{item.doctrNm}</p>
                                                                    <span className={style['part-txt']}>{item.clnicCntn}</span>
                                                                    <span className={style['date']}>{item.clnicDt} 진료</span>
                                                                </div>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>

                                            {doctorList.length > 5 &&
                                                <button className='btn' data-btn-type="fill-gray-dark" data-btn-size='smd' data-btn-width='full' onClick={() => navigate(URL.DOCTOR_MORE)}>
                                                    <span>{doctorListCnt}개 더 보기</span>
                                                </button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                            {/* 주치의 정보:: E */}

                            <div className={style['download-btn-box']}>
                                <button className='btn' data-btn-type="fill-main-sub" data-btn-size='lg' data-btn-width='full' data-btn-icon='download' onClick={() => setDownloadOpen(!downloadOpen)}>
                                    <span>다운로드</span>
                                </button>
                            </div>

                            <div className={style['setting-btn-box']}>
                                <button className={style['setting-btn']} onClick={() => navigate(URL.MY_DATA_VIEW_SETTING, { state: { summaryViewInfo: summaryViewInfo } })}>
                                    <span>화면설정</span>
                                </button>
                            </div>

                            {/* 꼭 확인해주세요:: S */}
                            <div className={style['content-box']}>
                                <div className={style['title-box']}>
                                    <div className={style['left']}>
                                        <p>꼭 확인해주세요!</p>
                                    </div>
                                </div>

                                <div className={style['content']}>
                                    <div className={style['info-list-box']}>
                                        <ul>
                                            <li>
                                                <p>해당 정보는 연결된 성모 병원 데이터를 기반으로 구성되었습니다.</p>
                                            </li>
                                            <li>
                                                <p>신규 병원 연결, 기존 병원 연결 해제는 전체 메뉴 &gt; 설정 &gt; 내 병원 설정에서 가능합니다.</p>
                                                <button className={style['shortcut']} onClick={() => navigate(URL.MY_HOSPITAL_SETTING)}>
                                                    <span>바로가기↗</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* 꼭 확인해주세요:: E */}
                        </>
                    )}

                    <BottomSheet
                        scrollLocking={false}
                        expandOnContentDrag={false}
                        open={open}
                        onDismiss={onDismiss}
                        snapPoints={({ minHeight }) => minHeight}
                        blocking={false}
                    >
                        <MyInfoHelpGuideBox onClose={onDismiss} code={infoNum} />
                    </BottomSheet>

                    <BottomSheet
                        scrollLocking={false}
                        expandOnContentDrag={false}
                        open={openGraph}
                        onDismiss={onGraphDismiss}
                        snapPoints={({ minHeight }) => minHeight}
                        blocking={true}
                    >
                        <InspectionGraphBox
                            onClose={onGraphDismiss}
                            title={targetExamRsltList.title}
                            data={targetExamRsltList.data}
                            range={targetExamRsltList.range}
                        />
                    </BottomSheet>
                </div>
            </div>

            {/*    모달창    */}
            <Modal isOpen={isUpdateOpen} setIsOpen={setIsUpdateOpen}>
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p> 의료 정보를 업데이트 하시겠어요?</p>
                            <p> 업데이트 시 아래 정보들이 최신화됩니다. </p>
                        </div>
                        <div className='sub-box'>
                            <span>주요 진단, 주요 수술력/처치력, 주요 약물력,</span>
                            <span>주요 검사 결과, 주치의 정보</span>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="outline-main" data-btn-size="md" onClick={() => setIsUpdateOpen(false)}>
                                <span>취소</span>
                            </button>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={updateLoading}>
                                <span>업데이트</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal isOpen={isUpdateLoadingOpen} setIsOpen={setIsUpdateLoadingOpen}>
                <div className='modal-box' data-type="loading">
                    <div className='modal-top-box m-t-0'>
                        <div className='title-box'>
                            <p> 의료 정보 업데이트 중</p>
                        </div>
                        <div className='sub-box' data-color="main-gray-5">
                            <span>잠시만 기다려주세요! </span>
                        </div>
                    </div>
                    <div className="modal-bottom-box">
                        <div className='loading-lists-box'>
                            <ul>
                                {usrHsptlMap.length > 0 &&
                                    usrHsptlMap.map((item, idx) => {
                                        return (
                                            item.isUpdate ?
                                                <li key={'loading_ok_' + idx} data-loading="ok">
                                                    <p>{item.cnncHsptlNm}</p>
                                                    <div className="loading-box">
                                                        <div className='finish-chk' data-finish="on">
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </li>
                                                :
                                                <li key={'loading_no_' + idx}>
                                                    <p>{item.cnncHsptlNm}</p>
                                                    <div className="loading-box">
                                                        <CircularProgress size="16px" />
                                                    </div>
                                                </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal isOpen={isCompleteOpen} setIsOpen={setIsCompleteOpen}>
                <div className='modal-box' data-type="b">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p style={{ whiteSpace: 'pre-line' }}>{isUpdateCompleteMsg}</p>
                        </div>
                    </div>
                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={() => setIsCompleteOpen(false)}>
                                <span>확인</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal isOpen={downloadOpen} setIsOpen={setDownloadOpen}>
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p> 요약 정보를 다운로드 하시겠어요? </p>
                            <p> 다운로드 시 PDF 파일이 </p>
                            <p> 디바이스에 저장됩니다.</p>
                        </div>
                        <div className='sub-box'>
                            <span>개인정보 보호를 위하여 </span>
                            <span>본인의 생년월일 여섯자리가</span>
                            <span>파일 비밀번호로 자동 설정됩니다.</span>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="outline-main" data-btn-size="md" onClick={() => setDownloadOpen(false)}>
                                <span>취소</span>
                            </button>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={handleDownload}>
                                <span>다운로드</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal isOpen={downloadLoadingOpen} setIsOpen={setDownloadLoadingOpen}>
                <div className='modal-box' data-type="loading" onClick={downloadComplete}>
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p> 파일 다운로드 중...</p>
                        </div>
                    </div>
                    <div className="modal-bottom-box p-b-16">
                        <div className='loading-box'>
                            <CircularProgress size="3.2rem" />
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal isOpen={downloadCompleteOpen} setIsOpen={setDownloadCompleteOpen}>
                <div className='modal-box' data-type="b">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p> 다운로드가 완료되었어요!</p>
                        </div>
                        <div className='sub-box'>
                            <span>다운로드 폴더를 확인해보세요</span>
                        </div>
                    </div>
                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="lg" onClick={() => setDownloadCompleteOpen(false)}>
                                <span>확인</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )}
        </>
    )
}

export default MyDataSummary